import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { AuthorisationState } from './types';
const selectCache = (state: RootState) => state.authorisationCache;
export const selectAuthorisations = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisations
);
export const selectAuthorisationOrderProcess = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisationOrderProcess
);
export const selectAuthorisationProcess = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisationProcess
);
export const selectAuthorisationListingError = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisationListingError
);
export const selectSelectedAuthorisation = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.selectedAuthorisation
);
export const selectTotalAuthorisations = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.totalAuthorisations
);
export const selectAuthorisationError = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.displayErrorMessage
);
export const selectAuthorisationTypesOption = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisationTypesOption
);

export const selectAuthorisationPurchaseId = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisationPurchaseId
);
export const selectAuthorisationPurchaseType = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisationPurchaseType
);
export const selectAuthorisationPurchaseQuantity = createSelector(
  selectCache,
  (cache: AuthorisationState) => cache.authorisationPurchaseQuantity
);
